document.addEventListener( 'DOMContentLoaded', () => {
	const button	= document.querySelector( '.ucllb-to-top' );
	const link		= document.querySelector( '.ucllb-to-top__link' );

	if( !button ){
		return;
	}

	const threshold = 24;
	let updating = false;

	const update = () => {
		const show = window.scrollY > threshold;

		button.hidden = !show;
		button.setAttribute( 'aria-hidden', show ? 'false' : 'true' );
		button.classList.toggle( 'is-visible', show );

		updating = false;
	};

	const onScroll = () => {
		if( updating ){
			return;
		}

		updating = true;
		window.requestAnimationFrame( update );
	};

	update();

	link.addEventListener( 'click', e => {
		e.preventDefault();
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	});

	[ 'scroll', 'resize' ].forEach( e => window.addEventListener( e, onScroll, { passive: true } ) );
});